import React, {Component} from "react"

class MenuView extends Component {
    render() {
        return (
          <div className="content container">
            <div id="carouselExampleControls" className="carousel slide full-width-carrousel" data-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div style={{background: "url('/images/menu/header.png') no-repeat center"}}><span
                    style={{display: "inline-block", height: "10rem"}}></span></div>
                </div>
              </div>
              {/* <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a> */}
            </div>
            <h2>Menukaart</h2>
            <p>Ontdek onze menukaart op <a href="https://icemonkey.be/">www.icemonkey.be</a></p>
    </div>
    )
    }
}

export default MenuView
